// import {getConfig} from 'api';

import Utils from "../utils/utils";

class ProductList {

    constructor(lang, enableDebug) {
        this.lang = lang;
        this.enableDebug = enableDebug;
    }

    async run() {
        console.log('>> Initializing Product Listing code');

        this.config = window['roProductsConfig'];
        if (!this.config) {
            console.error('roProductsConfig not found, skipping code execution');
            return;
        }

        for (const [productId, config] of Object.entries(this.config.js)) {
            if (config.debug && !this.enableDebug) {
                console.log(`Skipping product ${productId} since it's configured as a debug product but debug option is not enabled`);
                continue;
            }
            // console.log(`Processing pId ${productId}`, config);

            for (const [opId, opConfig] of Object.entries(config)) {
                // console.log('Searching for op ', opId)
                if (opId in this &&
                    typeof this[opId] === "function") {
                    this[opId](productId, opConfig).catch((e) => {
                        console.info(`Could not apply op ${opId} for product ${productId}`);
                    });
                }
            }

        }

    }

    async capsuleNewLabel(productId, config)
    {
        console.log(`>>> Adding capsuleNewLabel for product code ${productId}`);
        (await Utils.wait(`[data-product-item-id="${productId}"] .ProductListElement__name`))
            .append(config.PLP);
    }

    async capsuleLimitedEditionLabel(productId, config)
    {
        console.log(`>>> Adding capsuleLimitedEditionLabel for product code ${productId}`);
        (await Utils.wait(`[data-product-item-id="${productId}"] .ProductListElement__intensity`))
            .append(config.PLP);
    }

    async capsuleBestSellerLabel(productId, config)
    {
        console.log(`>>> Adding capsuleBestSellerLabel for product code ${productId}`);
        (await Utils.wait(`[data-product-item-id="${productId}"] .ProductListElement__intensity`))
            .append(config.PLP);
    }

    async capsuleFreeDeliveryLabel(productId, config)
    {
        console.log(`>>> Adding capsuleFreeDeliveryLabel for product code ${productId}`);
        (await Utils.wait(`[data-product-item-id="${productId}"] .ProductListElement__intensity`))
            .append(config.PLP);
    }

    async capsulePromoBadge(productId, config)
    {
        console.log(`>>> Adding capsulePromoBadge for product code ${productId}`);
        (await Utils.wait(`[data-product-item-id="${productId}"]`))
            .append(config.PLP);
    }

    async machineNewLabel(productId, config)
    {
        console.log(`>>> Adding machineNewLabel for product code ${productId}`);
        (await Utils.wait(`[data-product-item-id="${productId}"] .ProductListElement__name`))
            .append(config.PLP);
    }

    async machineBestSellerLabel(productId, config)
    {
        console.log(`>>> Adding machineBestSellerLabel for product code ${productId}`);
        (await Utils.wait(`[data-product-item-id="${productId}"] .ProductListElement__information`))
            .append(config.PLP);
        (await Utils.wait(`[data-product-item-id="${productId}"]`))
            .addClass('articleHighlight');
    }

    async accessoriesBestSellerLabel(productId, config)
    {
        console.log(`>>> Adding accessoriesBestSellerLabel for product code ${productId}`);
        (await Utils.wait(`[data-product-item-id="${productId}"] .ProductListElement__name--accessory`))
            .append(config.PLP);
    }

    async promoBadge(productId, config)
    {
        console.log(`>>> Adding promoBadge for product code ${productId}`);
        (await Utils.wait(`[data-product-item-id="${productId}"] .ProductListElement__price`))
            .append(config.PLP)
    }

    async newPrice(productId, config)
    {
        console.log(`>>> Adding newPrice for product code ${productId}`);
        (await Utils.wait(`[data-product-item-id="${productId}"] .ProductListElement__price`))
            .addClass('genericPriceColor');
        (await Utils.wait(`[data-product-item-id="${productId}"] .ProductListElement__price`))
            .append(config.PLP);
    }

    async machineSubscription(productId, config)
    {
        console.log(`>>> Adding machineSubscription for product code ${productId}`);
        (await Utils.wait(`[data-product-item-id="${productId}"] .ProductListElement__price`))
            .append(config.PLP);
        (await Utils.wait(`[data-product-item-id="${productId}"]`))
            .addClass('subscriptionArticleHeight');
    }

}

export default ProductList;
